import script from "./NewConference.vue?vue&type=script&setup=true&lang=js"
export * from "./NewConference.vue?vue&type=script&setup=true&lang=js"

import "./NewConference.vue?vue&type=style&index=0&id=aea3e92c&lang=scss"

const __exports__ = script;

export default __exports__